module.exports = __webpack_public_path__ + "img/16k017-09.9130f7bd.png";